// document.addEventListener("DOMContentLoaded", function() {
//   var targetClass = '.content-Savybėsirprivalumai';

//   // Function to format the list
//   function formatMetafieldList() {
//     var elements = document.querySelectorAll(targetClass);
    
//     // Safety check: if no elements found, do nothing yet
//     if (elements.length === 0) return;

//     elements.forEach(function(element) {
//       // Avoid processing the same element twice
//       if (element.getAttribute('data-formatted') === 'true') return;

//       console.log('Found element:', element);
      
//       var currentText = element.innerText;
//       var sentences = currentText.split('.').filter(function(s) {
//         return s.trim().length > 0;
//       });

//       console.log('Sentences found:', sentences);

//       if (sentences.length > 0) {
//         var listHtml = '<ul>';
//         sentences.forEach(function(sentence) {
//           listHtml += '<li>' + sentence.trim() + '.</li>';
//         });
//         listHtml += '</ul>';
//         element.innerHTML = listHtml;
        
//         // Mark as done so we don't re-loop it
//         element.setAttribute('data-formatted', 'true');
//       }
//     });
//   }

//   // 1. Try to run it immediately (in case it IS already there)
//   formatMetafieldList();

//   // 2. Set up an observer to watch for new elements being added
//   var observer = new MutationObserver(function(mutations) {
//     // Whenever the DOM changes, try to format again
//     formatMetafieldList();
//   });

//   // Start observing the document body
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });

//    document.addEventListener("DOMContentLoaded", function () {
//             var targetClass = '.content-Savybėsirprivalumai';

//             // Function to format the list
//             function formatMetafieldList() {
//                 var elements = document.querySelectorAll(targetClass);

//                 // Safety check: if no elements found, do nothing yet
//                 if (elements.length === 0) return;

//                 elements.forEach(function (element) {
//                     // Avoid processing the same element twice
//                     if (element.getAttribute('data-formatted') === 'true') return;

//                     console.log('Found element:', element);

//                     var currentText = element.innerText;
//                     // Original logic: split by period
//                     var sentences = currentText.split('.').filter(function (s) {
//                         return s.trim().length > 0;
//                     });

//                     console.log('Sentences found:', sentences);

//                     if (sentences.length > 0) {
//                         var listHtml = '<ul>';
//                         sentences.forEach(function (sentence) {
//                             listHtml += '<li>' + sentence.trim() + '.</li>';
//                         });
//                         listHtml += '</ul>';
//                         element.innerHTML = listHtml;

//                         // Mark as done so we don't re-loop it
//                         element.setAttribute('data-formatted', 'true');
//                     }
//                 });
//             }

//             // 1. Try to run it immediately (in case it IS already there)
//             formatMetafieldList();

//             // 2. Set up an observer to watch for new elements being added
//             var observer = new MutationObserver(function (mutations) {
//                 // Whenever the DOM changes, try to format again
//                 formatMetafieldList();
//             });

//             // Start observing the document body
//             observer.observe(document.body, {
//                 childList: true,
//                 subtree: true
//             });
//         });

document.addEventListener("DOMContentLoaded", function() {
  var targetClass = '.content-Savybėsirprivalumai';

  // Function to format the list
  function formatMetafieldList() {
    var elements = document.querySelectorAll(targetClass);
    
    // Safety check: if no elements found, do nothing yet
    if (elements.length === 0) return;

    elements.forEach(function(element) {
      // Avoid processing the same element twice
      if (element.getAttribute('data-formatted') === 'true') return;

      console.log('Found element:', element);
      
      var currentText = element.innerText;

      // CHANGE: Split by newline character (enter key) instead of period.
      // This keeps sentences on the same line together.
      var sentences = currentText.split(/\r?\n/).filter(function(s) {
        return s.trim().length > 0;
      });

      console.log('Lines found:', sentences);

      if (sentences.length > 0) {
        var listHtml = '<ul>';
        sentences.forEach(function(sentence) {
          // We trim the line but don't force adding a '.' because it likely already has one.
          listHtml += '<li>' + sentence.trim() + '</li>';
        });
        listHtml += '</ul>';
        element.innerHTML = listHtml;
        
        // Mark as done so we don't re-loop it
        element.setAttribute('data-formatted', 'true');
      }
    });
  }

  // 1. Try to run it immediately (in case it IS already there)
  formatMetafieldList();

  // 2. Set up an observer to watch for new elements being added
  var observer = new MutationObserver(function(mutations) {
    // Whenever the DOM changes, try to format again
    formatMetafieldList();
  });

  // Start observing the document body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// start translation - compare app
  // function updateLabels() {

  //   // Change Color → Spalva
  //   document.querySelectorAll('.htc-header.action-li').forEach(function(el) {
  //     if (el.textContent.trim() === 'Color') {
  //       el.textContent = 'Spalva';
  //     }
  //   });

  //   // Change Add Product → Pridėti produktą
  //   document.querySelectorAll('.htc-table-image span').forEach(function(el) {
  //     if (el.textContent.trim() === 'Add Product') {
  //       el.textContent = 'Pridėti produktą';
  //     }
  //   });

  // }

  function updateLabels() {

  const colorEls = document.querySelectorAll('.htc-header.action-li');
  colorEls.forEach(function(el) {
    if (el.textContent.trim() === 'Color') {
      el.textContent = 'Spalva';
    }
  });

  const addProductEls = document.querySelectorAll('.htc-table-image span');
  addProductEls.forEach(function(el) {
    if (el.textContent.trim() === 'Add Product') {
      el.textContent = 'Pridėti produktą';
    }
  });

}
  // Run once
  updateLabels();

  // Watch for elements added later (third-party app)
  const observer = new MutationObserver(function() {
    updateLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // end translation - compare app